import { _t } from '@/locale';
import { SortOption } from '@/types/state/search';
import { SortedBy } from './Sorting.types';

export const SORTING_OPTIONS: SortedBy[] = [
  { value: 'popular', label: _t('sorting_popular') },
  { value: 'closest', label: _t('sorting_closest') },
  { value: 'availability', label: _t('sorting_availability') },
  { value: 'reviews_score', label: _t('sorting_rating_score') },
  { value: 'smt_discount', label: _t('sorting_smt_discount') },
  { value: 'highest_discount', label: _t('sorting_highest_discount') },
];

export const DEFAULT_SORTING_OPTION: SortedBy = {
  value: 'popular',
  label: _t('sort'),
};
export const SMT_DEFAULT_SORTING_OPTION: SortedBy = {
  value: 'smt_discount',
  label: _t('sort'),
};

export const NEAR_ME_DEFAULT_SORTING_OPTION: SortedBy = {
  value: 'closest',
  label: _t('sort'),
};

export function getAppliedSorting(
  sort?: SortOption,
  isSistaminutenSearch?: boolean,
  isNearMeSearch?: boolean,
): SortedBy {
  const defaultOption = (() => {
    if (isSistaminutenSearch) return SMT_DEFAULT_SORTING_OPTION;
    if (isNearMeSearch) return NEAR_ME_DEFAULT_SORTING_OPTION;
    return DEFAULT_SORTING_OPTION;
  })();

  return SORTING_OPTIONS.find((option) => option.value === sort) || defaultOption;
}
